import React from "react";
import Link, { LinkToNewTab } from "../../Elements/Link/Link.js";
import Icon from "../../Elements/Icon/Icon.tsx";

export const MobileBottomSection = () => {
  return (
    <div className="footer-bottom-section footer-mobile-bottom-section">
      <div className="footer-bottom-section-title-and-logos">
        <LinkToNewTab page={"home"}>
          <Icon
            name={"jumbomail-logo-small"}
            medium
            clickable
            white={true}
            title="JUMBOmail"
            alt="JUMBOmail"
          />
        </LinkToNewTab>
        <div className="footer-bottom-section-title">© JUMBOmail</div>
      </div>
    </div>
  );
};
